<template>
    <select
        v-if="typeof options == 'number'"
        v-validate="required ? 'truthy' : false"
        :data-vv-as="validateAsComputed"
        :data-vv-validate-on="validateOn"
        :ref="label"
        :name="label"
        @change="changeHandler"
        :id="label"
    >
        <option
            v-if="defaultOption"
            :value="false"
            disabled
            :selected="hasValue ? false : true"
            :key="defaultOption"
        >
            {{ defaultOption }}
        </option>
        <option
            v-for="val in options"
            :key='val'
            :value="val"
            :data-selected="isSelected(val)"
        >
            <span>
                <slot :slotKey="val"></slot>
            </span>
        </option>
    </select>
    <select
        v-else
        v-validate="required ? 'truthy' : false"
        :data-vv-as="validateAsComputed"
        :data-vv-validate-on="validateOn"
        :ref="label"
        :name="label"
        @change="changeHandler"
        :id="label"
    >
        <option
            v-if="defaultOption"
            :value="false"
            disabled
            :selected="hasValue ? false : true"
            :key="defaultOption"
        >
            {{ defaultOption }}
        </option>
        <option
            v-for="(option, key) in options"
            :key='option'
            :value="useKey ? key: option"
            @change="changeHandler"
            :data-key="key"
            :data-selected="isSelected(option)"
        >
            <span>
                <slot :slotKey="key"></slot>{{ shrinkContent ? option.slice(0, 3) : option }}
            </span>
        </option>
    </select>
</template>

<script>
import { mapState } from 'vuex';
import { createCustomSelect, getPopperElement, updateSelectOptions } from '@H/custom-select';
import popperManager from '@M/popperManager';

export default {
    mixins: [popperManager],
    inject: ['$validator'],
    name: 'CustomSelect',
    data() {
        return {
            value: null
        }
    },
    mounted() {
        this.popperId = createCustomSelect(this.$refs[this.label]);
        this.toggleSelectDisability(this.disabledCheck);
        // True as first time run
        this.handler(this.$refs[this.label], true);
        // Checks if single options and restricts functionality
        if (typeof this.options == 'object') {
            if (Object.keys(this.options).length < 2) {
                let innerSelect = this.$refs[this.label];
                let customSelect = innerSelect.parentNode;

                customSelect.classList.add('is-single');
            }
        } else if (typeof this.options == 'array') {
            if (this.options.length < 2) {
                let innerSelect = this.$refs[this.label];
                let customSelect = innerSelect.parentNode;

                customSelect.classList.add('is-single');
            }
        }
    },
    computed: {
        ...mapState(['formSubmitting']),
        validateAsComputed() {
            return this.validateAs || this.name;
        },
        isDisabled() {
            return this.disabledCheck || this.$store.state.formSubmitting;
        }
    },
    methods: {
        isSelected(opt) {
            if (!this.value) this.value = this.hasValue;
            return this.value && this.value == opt;
        },
        changeHandler: function (e) {
            if (this.handler) {
                this.$validator
                    ? this.$validator.validate(e.target.name, e.target.value)
                    : null;
                this.handler(e);
            }
        },
        toggleSelectDisability(val) {
            let innerSelect = this.$refs[this.label];
            let customSelect = innerSelect.parentNode;
            if (val) {
                customSelect.classList.add('is-disabled');
            } else {
                customSelect.classList.remove('is-disabled');
            }
        }
    },
    watch: {
        'options': function () {
            const wrapper = getPopperElement(this.popperId);
            const select = wrapper.querySelector('select');
            this.value = select.value;
            this.$nextTick(() => {
                updateSelectOptions(select);
            });
        },
        isDisabled(val) {
            this.toggleSelectDisability(val);
        }
    },
    props: {
        options: {
            type: [Array, Object, Number],
            required: true
        },
        label: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        handler: {
            type: Function
        },
        defaultOption: {
            type: [String, Number, Boolean],
            default: false
        },
        hasValue: {
            type: [String, Number, Boolean],
            default: false
        },
        useKey: {
            type: Boolean,
            default: false
        },
        validateAs: {
            type: String
        },
        validateOn: {
            type: String,
            default: 'change'
        },
        shrinkContent: {
            type: Boolean,
            default: false
        },
        disabledCheck: {
            type: Boolean,
            default: false
        }
    }
};
</script>





// WEBPACK FOOTER //
// resources/assets/js/components/CustomSelect.vue